// Emitted in place of a Notion result when the org has no usable Notion
// integration for this project. This is a card, not a failure: the tool
// succeeded in detecting the gap.
export interface NotionSetupRequiredPayload {
  type: "notion_setup_required";
  reason: "workspace_not_configured" | "not_exposed";
  capability?: string;
}

const REASONS: ReadonlySet<NotionSetupRequiredPayload["reason"]> = new Set(["workspace_not_configured", "not_exposed"]);

const isReason = (v: unknown): v is NotionSetupRequiredPayload["reason"] =>
  typeof v === "string" && REASONS.has(v as NotionSetupRequiredPayload["reason"]);

// Tolerates unknown reasons so a newer backend still renders the card.
export const parseNotionSetupRequiredPayload = (v: unknown): NotionSetupRequiredPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "notion_setup_required") return null;
  return {
    type: "notion_setup_required",
    reason: isReason(r.reason) ? r.reason : "workspace_not_configured",
    ...(typeof r.capability === "string" ? { capability: r.capability } : {}),
  };
};
